import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.ConversationStream'

export default defineMessages({
  feedAriaLabel: {
    id: `${scope}.feedAriaLabel`,
    defaultMessage: 'Procurify AI conversation',
  },
  typing: {
    id: `${scope}.typing`,
    defaultMessage: 'Procurify AI is thinking',
  },
  thinkingDefault: {
    id: `${scope}.thinkingDefault`,
    defaultMessage: 'Thinking…',
  },
  thinkingUnderstanding: {
    id: `${scope}.thinkingUnderstanding`,
    defaultMessage: 'Understanding your request…',
  },
  thinkingSearching: {
    id: `${scope}.thinkingSearching`,
    defaultMessage: 'Searching the catalog…',
  },
  thinkingRanking: {
    id: `${scope}.thinkingRanking`,
    defaultMessage: 'Ranking and filtering the results…',
  },
  thinkingPreparing: {
    id: `${scope}.thinkingPreparing`,
    defaultMessage: 'Preparing your request…',
  },
})
